import { Component, OnInit, Input, ChangeDetectionStrategy, ViewChild, 
    ElementRef, Renderer, ChangeDetectorRef, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { APP_SETTINGS } from 'angular-engine/modules/ng-express-engine/tokens';

@Component({
    selector: 'email-field',
    templateUrl: 'email-field.template.html',
    styleUrls: ['email-field.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmailField {
    @Input() placeholder: string;
    @ViewChild("input") input: ElementRef;

    public sending: boolean;
    public completed: boolean;
    private error: boolean;
    private subscription: Subscription;
    public rand: Number;
    model = new SignUp(null);
    constructor(
        private http: HttpClient, 
        private cd: ChangeDetectorRef,
        @Inject(APP_SETTINGS) private settings: Object
    ) {
        this.rand = Math.floor(Math.random() * 100);
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    submit(signupForm: any) {
        if (!signupForm.form.valid) return true;

        this.sending = true;
        this.error = false;
        const url = this.settings['DATA_API_ENDPOINT'] + '/subscribe';
        let formData: FormData = new FormData();
        formData.append("email_address", this.model.email_address);

        this.subscription = this.http
            .post(url, formData)
            .subscribe((data) => {
                if (data["status"] !== "sent") {
                    this.error = true;
                }
                else {
                    this.completed = true;
                    this.error = false
                }
                this.sending = false;
                this.cd.markForCheck()
            },
            (err) => {
                this.error = true;
                this.sending = false;
                this.cd.markForCheck()
            });
    }

    toggleSend(signupForm) {
        if (this.completed) {
            this.model.email_address = "";
            this.completed = false;
        }
        else if (!this.sending) {
            this.submit(signupForm);
        }
        return true;
    }
}

export class SignUp {
    constructor(
        public email_address: string,
    ) { }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/email-field/email-field.component.ts